var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinamarLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650.000000 650.000000",
    preserveAspectRatio: "xMidYMid meet",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,650.000000) scale(0.100000,-0.100000)",
    stroke: "none",
    fill: "rgba(196, 138, 13, 0.08)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1647 4532 l-1597 -1597 468 -468 467 -467 50 50 50 50 -415 415 -415 415 1498 1498 1497 1497 1490 -1490 c819 -819 1490 -1494 1490 -1500 0 -5 -187 -197 -415 -425 l-415 -415 50 -50 50 -50 470 470 470 470 -1598 1598 -1597 1597 -1598 -1598z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1977 4202 l-1267 -1267 1268 -1268 1267 -1267 293 292 292 293 -487 487 -488 488 485 485 485 485 -488 487 -487 488 490 490 490 490 -293 293 -292 292 -1268 -1268z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3560 4315 l-415 -415 410 -410 410 -410 417 417 418 418 -407 407 c-225 225 -410 408 -413 408 -3 0 -192 -187 -420 -415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4540 3335 l-415 -415 413 -413 413 -412 416 418 417 418 -410 410 c-225 225 -411 409 -414 409 -3 0 -192 -187 -420 -415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3573 2361 l-402 -407 409 -409 410 -410 405 405 405 405 -412 411 -413 411 -402 -406z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinamarLogo);
export default __webpack_public_path__ + "static/media/linamarLogo.b5655f35bee75005138416ca8c059a6b.svg";
export { ForwardRef as ReactComponent };